import {svgIconWrapper} from '../svg-icon-wrapper';

import FlagTriangleRegular from './flag-triangle-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <FlagTriangleRegular {...validProps} />;
}

SvgComponent.iconName = 'flag-triangle-regular';

export const FlagTriangleRegularIcon = svgIconWrapper(SvgComponent);
